import React, { useState } from "react";
import Button from "components/CustomButton";
import { ReactComponent as TeamInformationIcon } from "assets/img/icons/teaminfo.svg";
import Scrollbar from "react-scrollbars-custom";
import TeamInformation from "views/Teams/TeamInformation/TeamInformation";
import { Modal } from "react-responsive-modal";
import { ReactComponent as CloseIcon } from "assets/img/icons/cancel.svg";
import "assets/scss/partials/microsoftTeams.scss";

export default () => {
  const [dialog, setDialog] = useState(false);

  return (
    <>
      <Button
        buttonClass="invite-btn text-center microsoftTeamInformationButton"
        onClick={() => setDialog(true)}
      >
        <TeamInformationIcon style={{ fill: "white", width: "24px" }} />
        Team Information
      </Button>
      <Modal
        open={dialog}
        closeOnOverlayClick={false}
        onClose={() => setDialog(false)}
        showCloseIcon={false}
        center={true}
        classNames={{ modal: "microsoftTeamUserPollListDetail" }}
        closeOnEsc={false}
      >
        <div className="microsoftTeamsDialogHeader">
          {" "}
          Team Information
          <div className="closeMicrosoftTeamsDialog">
            <CloseIcon onClick={() => setDialog(false)} className="cursor" />
          </div>
        </div>
        <div style={{ padding: "0px 8px" }}>
          <Scrollbar style={{ height: "calc(100vh - 60px)" }}>
            <div>
              <div className="teamInformationModalContent">
                <TeamInformation />
              </div>
            </div>
          </Scrollbar>
        </div>
      </Modal>
    </>
  );
};
